import gql from 'graphql-tag'

export const JOKE_FIELDS = gql`
  fragment JokeFields on JokeType {
    id
    text
    credits
    rating
    score
    likesCount
    dislikesCount
    myVote
    authorName
    isLegacy
    category {
      name
      displayName
    }
    tags {
      slug
      label
      axis
      isSensitive
    }
  }
`

export const JOKES_QUERY = gql`
  query GetJokes($category: String, $count: Int, $offset: Int, $orderBy: OrderBy) {
    jokes(category: $category, count: $count, offset: $offset, orderBy: $orderBy) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const RANDOM_JOKE_QUERY = gql`
  query RandomJoke($tags: [String], $excludeTags: [String], $scoreFilter: String) {
    randomJoke(tags: $tags, excludeTags: $excludeTags, scoreFilter: $scoreFilter) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const JOKE_BY_ID_QUERY = gql`
  query JokeById($id: Int) {
    joke(id: $id) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const SEARCH_JOKES_QUERY = gql`
  query SearchJokes(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
    $count: Int
    $offset: Int
    $orderBy: OrderBy
  ) {
    searchJokes(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
      count: $count
      offset: $offset
      orderBy: $orderBy
    ) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

// Total number of results for the same filters — drives numbered pagination.
export const SEARCH_JOKES_COUNT_QUERY = gql`
  query SearchJokesCount(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
  ) {
    searchJokesCount(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
    )
  }
`

// Per-tag counts contextual to the current selection (live facet numbers).
export const TAG_FACETS_QUERY = gql`
  query TagFacets(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
  ) {
    tagFacets(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
    ) {
      slug
      label
      axis
      isSensitive
      jokeCount
    }
  }
`

export const DAILY_JOKE_QUERY = gql`
  query DailyJoke {
    dailyJoke {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const TAGS_QUERY = gql`
  query Tags($axis: String) {
    tags(axis: $axis) {
      slug
      label
      axis
      isSensitive
      jokeCount
    }
  }
`

export const CATEGORIES_QUERY = gql`
  query Categories {
    categories {
      name
      displayName
    }
    total
    newJokesCount
  }
`

export const VOTE_MUTATION = gql`
  mutation Vote($jokeId: Int!, $value: Int!) {
    vote(jokeId: $jokeId, value: $value) {
      myVote
      joke {
        id
        score
        likesCount
        dislikesCount
      }
    }
  }
`

export const SUBMIT_JOKE_MUTATION = gql`
  mutation SubmitJoke($text: String!, $tagSlugs: [String]) {
    submitJoke(text: $text, tagSlugs: $tagSlugs) {
      joke {
        ...JokeFields
      }
    }
  }
  ${JOKE_FIELDS}
`
